import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 col-xxl-6 col-sm-6 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 5 }
const _hoisted_13 = { key: 6 }
const _hoisted_14 = { key: 7 }
const _hoisted_15 = { key: 8 }
const _hoisted_16 = { key: 9 }
const _hoisted_17 = { key: 10 }
const _hoisted_18 = { class: "col-md-6 col-xxl-6 col-sm-6 mb-10" }
const _hoisted_19 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_20 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_21 = { class: "table" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { colspan: "2" }
const _hoisted_28 = { key: 5 }
const _hoisted_29 = { key: 6 }
const _hoisted_30 = { key: 7 }
const _hoisted_31 = { key: 8 }
const _hoisted_32 = { key: 9 }
const _hoisted_33 = { key: 10 }
const _hoisted_34 = { key: 11 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)),
            _createVNode(_component_router_link, {
              to: "/liste-demandes",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, null, -1),
                _createTextVNode("Retour", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              (_ctx.demande?.refDemande)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _cache[2] || (_cache[2] = _createElementVNode("td", null, "Référence", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.refDemande), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.nomCompletBeneficiaire)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("td", null, "Nom du bénéficiaire", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.nomCompletBeneficiaire), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.typeDemande)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("td", null, "Type de demande", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.typeDemande?.code) + " - " + _toDisplayString(_ctx.demande?.typeDemande?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.nouvelleAgence)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _cache[5] || (_cache[5] = _createElementVNode("td", null, "Nouvelle Agence", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.nouvelleAgence?.code) + " - " + _toDisplayString(_ctx.demande?.nouvelleAgence?.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.abonnement)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createElementVNode("td", null, "Abonnement", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.abonnement?.refAbo) + " - " + _toDisplayString(_ctx.demande?.abonnement?.adresseVirtuelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.telephoneBeneficiaire)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _cache[7] || (_cache[7] = _createElementVNode("td", null, "Téléphone du bénéficiaire", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.telephoneBeneficiaire), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.montant)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _cache[8] || (_cache[8] = _createElementVNode("td", null, "Montant", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.separateur(_ctx.demande?.montant)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.categorieBeneficiaire)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _cache[9] || (_cache[9] = _createElementVNode("td", null, "Catégorie", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.categorieBeneficiaire?.code) + " - " + _toDisplayString(_ctx.demande?.categorieBeneficiaire?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.secteurActiviteBeneficiaire)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _cache[10] || (_cache[10] = _createElementVNode("td", null, "Secteur d'activité", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.secteurActiviteBeneficiaire?.code) + " - " + _toDisplayString(_ctx.demande?.secteurActiviteBeneficiaire?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.dateAcceptation)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _cache[11] || (_cache[11] = _createElementVNode("td", null, "Date d'acceptation", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_date( _ctx.demande?.dateAcceptation)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.dateValidation)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _cache[12] || (_cache[12] = _createElementVNode("td", null, "Date de validation", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_date( _ctx.demande?.dateValidation)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[24] || (_cache[24] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Autres informations", -1)),
          _createElementVNode("table", _hoisted_21, [
            _createElementVNode("tbody", null, [
              (_ctx.demande?.objet)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                    _cache[13] || (_cache[13] = _createElementVNode("td", null, "Objet", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.objet), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.autreObjet)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                    _cache[14] || (_cache[14] = _createElementVNode("td", null, "Autre objet", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.autreObjet), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.motif)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                    _cache[15] || (_cache[15] = _createElementVNode("td", null, "Motif", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.motif), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.contenu)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("td", { colspan: "2" }, "Contenu", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_ctx.demande?.contenu)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                    _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.demande?.contenu), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.status)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                    _cache[17] || (_cache[17] = _createElementVNode("td", null, "Statut", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.status), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.boite)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                    _cache[18] || (_cache[18] = _createElementVNode("td", null, "Boite", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.boite?.refBoite), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.abonne)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                    _cache[19] || (_cache[19] = _createElementVNode("td", null, "Abonné", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.abonne?.nomComplet), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.abonne)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                    _cache[20] || (_cache[20] = _createElementVNode("td", null, "Téléphone", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.abonne?.telephone), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.dateDemande)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                    _cache[21] || (_cache[21] = _createElementVNode("td", null, "Date de demande", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_date(_ctx.demande? _ctx.demande.createdAt : null)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.abonne?.categorieAbonne)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                    _cache[22] || (_cache[22] = _createElementVNode("td", null, "Categorie", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.abonne?.categorieAbonne?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.abonne?.activite)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                    _cache[23] || (_cache[23] = _createElementVNode("td", null, "Secteur", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.abonne?.activite?.libelle), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}